var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeLike(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8764 1.79568C12.0413 1.13954 10.8658 1.13953 10.0307 1.79568L3.23255 7.13707C2.3064 7.86476 1.76562 8.97738 1.76562 10.1552V18.1374C1.76562 19.8333 3.1404 21.2081 4.83627 21.2081H18.0708C19.7666 21.2081 21.1414 19.8333 21.1414 18.1374V10.1552C21.1414 8.97738 20.6006 7.86476 19.6745 7.13707L12.8764 1.79568Z",
    strokeWidth: 1.76004
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4422 17.1659L14.9893 13.6188L14.9872 13.6167L15.4657 13.1381C16.4452 12.1586 16.4452 10.5706 15.4657 9.59107C14.4862 8.61155 12.8981 8.61157 11.9186 9.59112L11.4403 10.0694L11.1139 9.74289C10.1344 8.76328 8.54621 8.76322 7.56666 9.74277C6.5872 10.7222 6.58715 12.3102 7.56654 13.2897L7.89332 13.6166L7.89109 13.6188L11.4422 17.1659ZM11.4422 17.1659L11.4402 17.1639",
    strokeWidth: 1.76004
  })));
}
export default SvgHomeLike;